import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MENU_ITEMS } from './menu.constants';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    private platformSource = new BehaviorSubject<string>(this.detectPlatform());
    currentPlatform$ = this.platformSource.asObservable();

    private detectPlatform(): string {
        const platform = navigator.platform.toLowerCase();
        const userAgent = navigator.userAgent.toLowerCase();
        let platformName = 'windows';

        if (platform.includes('mac') || userAgent.includes('mac os')) {
            platformName = 'macos';
        } else if (platform.includes('win') || userAgent.includes('windows')) {
            platformName = 'windows';
        } else if (userAgent.includes('android')) {
            platformName = 'android';
        } else if (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ios')) {
            platformName = 'ios';
        } else if (userAgent.includes('linux')) {
            platformName = 'linux';
        }
        return platformName;
    }

    changePlatform(platform: string) {
        this.platformSource.next(platform);
    }

    getPlatformLabel(): string {
        const currentPlatform = this.platformSource.getValue();
        const menuItem = MENU_ITEMS.find(item => item.icon === currentPlatform);
        return menuItem ? menuItem.label : currentPlatform;
    }
}